import {
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverContent,
  PopoverHeader,
  PopoverTrigger,
} from "@chakra-ui/popover";
import { Portal } from "@chakra-ui/portal";
import React from "react";

function CustomToolTip(props: any) {
  return (
    <Popover
      trigger="click"
      placement="bottom"
      strategy="fixed"
      isLazy
    >
      <PopoverTrigger>
        <div className="inline-flex items-center ctt-trigger">
          {props?.trigger}
        </div>
      </PopoverTrigger>

      <Portal>
        <PopoverContent
          border="1px solid #e2e8f0"
          borderRadius="12px"
          boxShadow="0 8px 32px rgba(15,23,42,0.12), 0 2px 8px rgba(15,23,42,0.06)"
          bg="white"
          p="0"
          overflow="hidden"
          zIndex={9999}
          className="ctt-content"
          _focus={{ outline: "none", boxShadow: "0 8px 32px rgba(15,23,42,0.12)" }}
        >
          {props?.header && (
            <PopoverHeader
              fontSize="12px"
              fontWeight="700"
              color="#0f172a"
              borderBottom="1px solid #f1f5f9"
              px="14px"
              py="10px"
              bg="linear-gradient(90deg,rgba(99,102,241,.06),rgba(99,102,241,.02))"
            >
              {props.header}
            </PopoverHeader>
          )}
          <PopoverArrow bg="white" boxShadow="-1px -1px 0px #e2e8f0" />
          <PopoverBody
            className="ctt-body"
            fontSize="12px"
            color="#475569"
            px="14px"
            py="12px"
            maxH="50vh"
            overflowY="auto"
          >
            {props?.content}
          </PopoverBody>
        </PopoverContent>
      </Portal>

      <style>{`
        .ctt-body::-webkit-scrollbar { width: 4px; }
        .ctt-body::-webkit-scrollbar-thumb { background: #cbd5e1; border-radius: 4px; }

        .chakra-popover__popper {
          z-index: 9999 !important;
          max-width: calc(100vw - 24px) !important;
        }

        .ctt-content {
          width: 400px;
          max-width: 400px;
        }

      `}</style>
    </Popover>
  );
}

export default CustomToolTip;